import HTTP from '@/utils/http-common';
import { encodeOpts } from '@/utils/encode-opts';

export const getDistributors = (params) =>
  HTTP.get('/distributors', {
    params,
    paramsSerializer: encodeOpts
  });
export const getDistributor = (distributor) => HTTP.get('/distributors/my');
export const getDistributorById = (distributorId) => HTTP.get(`/distributors/${distributorId}`);
export const createDistributor = (distributor) => HTTP.post('/distributors', distributor);
export const updateDistributor = (distributor) => HTTP.put(`/distributors/${distributor._id}`, distributor);
export const cancelDistributor = (distributor) => HTTP.put(`/distributors/${distributor._id}/cancel`, distributor);
export const updateDistributorPlan = (distributorId, action, plan) =>
  HTTP.patch(`/distributors/${distributorId}/plans`, { action, plan });
export const updateDistributorAddress = (address) => HTTP.put('/distributors/addresses', address);
export const createDistributorAddress = (address) => HTTP.post('/distributors/addresses', address);
export const deleteDistributorAddress = (addressId) => HTTP.delete(`/distributors/addresses/${addressId}`);
export const updateDistributorContact = (contact) => HTTP.put('/distributors/contacts', contact);
export const createDistributorContact = (contact) => HTTP.post('/distributors/contacts', contact);
export const deleteDistributorContact = (contactId) => HTTP.delete(`/distributors/contacts/${contactId}`);
